import React, { Component } from 'react';
import PropTypes from 'prop-types';

// @atlaskit
import Page from '@atlaskit/page';
import Button, { ButtonGroup } from '@atlaskit/button';
import MobileHeader from '@atlaskit/mobile-header';

// @source
import { Navigation, CoverageSpinner, RouteLink } from '../components';

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerState: 'none',
    };

    this.handleNavOpen = this.handleNavOpen.bind(this);
    this.handleNavClose = this.handleNavClose.bind(this);
  }

  handleNavOpen() {
    this.setState({ drawerState: 'navigation' });
  }

  handleNavClose() {
    this.setState({ drawerState: 'none' });
  }

  render() {
    const isMobile = window.outerWidth < 768;
    const { drawerState } = this.state;
    const { isLoading, children } = this.props;

    return (
      <Page navigation={isMobile ? null : <Navigation />}>
        {isMobile && (
          <MobileHeader
            drawerState={drawerState}
            navigation={isOpen => isOpen && <Navigation />}
            menuIconLabel="Menu"
            secondaryContent={(
              <ButtonGroup>
                <Button component={RouteLink} href="/account/logout">Logout</Button>
              </ButtonGroup>
            )}
            pageHeading="RBS Report"
            onNavigationOpen={this.handleNavOpen}
            onDrawerClose={this.handleNavClose}
          />
        )}
        {isLoading ? <CoverageSpinner /> : children}
      </Page>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.node,
  isLoading: PropTypes.bool,
};

Layout.defaultProps = {
  children: '',
  isLoading: false,
};

export default Layout;
